import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { UserInfo, FreeAd, PaidAd, CreatePassword } from '../Items'
import { getListings } from 'SRC/modules/ads/lisitings/selectors'
import { fetchListings } from 'SRC/modules/ads/lisitings/actions'
import { notificationTypes } from '../../../constants'

class List extends React.Component {
  componentDidMount () {
    if (!this.props.listings || !this.props.listings.length) {
      this.props.fetchListings()
    }
  }
  getNotification = type => {
    switch (type) {
      case notificationTypes.USER_INFO:
        return UserInfo
      case notificationTypes.USER_ADDED_FREE_AD:
        return FreeAd
      case notificationTypes.USER_ADDED_PAID_AD:
        return PaidAd
      case notificationTypes.USER_MUST_CREATE_PASSWORD:
        return CreatePassword
      default:
        return null
    }
  }

  getPropsForNotification = item => {
    try {
      switch (item.type) {
        case notificationTypes.USER_INFO:
          return {
            name: item.info.name,
            login: item.info.username
          }
        case notificationTypes.USER_ADDED_FREE_AD:
          return {
            code: item.info.code
          }
        case notificationTypes.USER_ADDED_PAID_AD:
          const { listings } = this.props
          console.log('props', this.props)
          const listingId = item.info.ad.listing
          const listing = listings.find(listingItem => listingItem.id === listingId)
          if (listing) item.info.ad.listing = listing
          return {
            name: item.info.user.name,
            surname: item.info.user.surname,
            userId: item.info.user.id,
            addons: item.info.user.activeAddons,
            phone: item.info.user.phones[0].phone,
            code: item.info.ad.code,
            listingId: item.info.ad.listing.id,
            packageName: item.info.ad.listing.name,
            packageCost: item.info.ad.listing.price,
            packageDuration: item.info.ad.listing.duration,
            promoRequest: item.info.ad.promoRequest
          }
        case notificationTypes.USER_MUST_CREATE_PASSWORD:
          return {
            name: item.info.name,
            login: item.info.username
          }
        default:
          return {}
      }
    } catch (e) {
      return {}
    }
  }

  render () {
    return (
      <div className='registracija-content'>
        <div className='registracija-content-form korisnicki-profil'>
          {
            this.props.notifications.map(item => {
              const Component = this.getNotification(item.type)
              return <Component {...this.getPropsForNotification(item)} key={item.type} />
            })
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  listings: getListings(state)
})

List.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    info: PropTypes.object.isRequired
  })).isRequired,
  listings: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  })).isRequired,
  fetchListings: PropTypes.func.isRequired
}

List.defaultProps = {
  notifications: []
}

export default connect(mapStateToProps, { fetchListings })(List)
